module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section01_03_american-village-9dafd200b4ccda43bf904145f2f27a30.jpg";